import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

type Variant = "signal" | "neutral";
type Size = "md" | "sm";

type BaseProps = {
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
};

type AnchorProps = BaseProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "className" | "children"> & {
    href: string;
  };

type ButtonProps = BaseProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className" | "children"> & {
    href?: undefined;
  };

export type KeycapButtonProps = AnchorProps | ButtonProps;

export function KeycapButton(props: KeycapButtonProps) {
  const { variant = "signal", size = "md", icon, children, className } = props;
  const classes = cn(
    "keycap",
    variant === "signal" ? "keycap-signal" : "keycap-neutral",
    size === "sm" && "keycap-sm",
    className,
  );

  if (props.href !== undefined) {
    const { variant: _v, size: _s, icon: _i, children: _c, className: _cn, ...rest } = props;
    return (
      <a className={classes} {...rest}>
        {icon}
        <span>{children}</span>
      </a>
    );
  }

  const { variant: _v, size: _s, icon: _i, children: _c, className: _cn, href: _h, ...rest } = props;
  return (
    <button className={classes} {...rest}>
      {icon}
      <span>{children}</span>
    </button>
  );
}
